import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"

import { mapPriceGroupName } from "entities/projects/graphql/special-price-groups/mapPriceGroupName"

export const priceResponseTransformer = createResponseTransformer(json => {
  if (Array.isArray(json.data)) {
    throw new Error("Received price array but expected a single price object")
  }
  const deserializedResult = serializer.deserialize(json.data.type, json)

  return {
    ...deserializedResult,
    itemPrice: deserializedResult.itemPrice || deserializedResult.price,
    groups: mapPriceGroupName(
      deserializedResult.groups || [],
      deserializedResult.id
    ),
    isValid: true
  }
})
